import { render, staticRenderFns } from "./no-team-message.vue?vue&type=template&id=2ce7a5c5&scoped=true&"
import script from "./no-team-message.vue?vue&type=script&lang=js&"
export * from "./no-team-message.vue?vue&type=script&lang=js&"
import style0 from "./no-team-message.vue?vue&type=style&index=0&id=2ce7a5c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce7a5c5",
  null
  
)

export default component.exports